import { createSlice } from "@reduxjs/toolkit";
import { getLocalStorage, setLocalStorage } from "../../../helperFunctions/localStorage";

const initialState: any = {
    logoUrl:getLocalStorage("logoUrl"),

};
const siteSettingSlice = createSlice({
  name: "siteSetting",
  initialState,
  reducers: {
    setSiteSetting(state, action) {
        setLocalStorage("logoUrl",action.payload.logoUrl)

      return action.payload;
    },
  
  },
  
});
export const {setSiteSetting}=siteSettingSlice.actions
export default siteSettingSlice.reducer

